export const employeeProgramOrderStatusNew = 1001;
export const employeeProgramOrderStatusWaitingPayment = 1002;
export const employeeProgramOrderStatusWaitingForApprove = 1003;
export const employeeProgramOrderStatusProcessing = 1004;
export const employeeProgramOrderStatusCompleted = 1005;
export const employeeProgramOrderStatusCancelled = 1006;
export const employeeProgramOrderStatusRebundled = 1007;

export const employeeProgramOrderStatusOptions = [
  { value: employeeProgramOrderStatusNew, label: 'Mới tạo' },
  { value: employeeProgramOrderStatusWaitingPayment, label: 'Chờ thanh toán' },
  { value: employeeProgramOrderStatusWaitingForApprove, label: 'Chờ xác nhận' },
  { value: employeeProgramOrderStatusProcessing, label: 'Chờ khớp' },
  { value: employeeProgramOrderStatusCompleted, label: 'Hoàn tất' },
  { value: employeeProgramOrderStatusCancelled, label: 'Đã hủy' },
  { value: employeeProgramOrderStatusRebundled, label: 'Đã đóng gói lại' },
];
